
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { META_INFO } from '../../config/meta.config';
import { ProjdataService } from '../projdata.share.service';


@Injectable({
  providedIn: 'root'
})
export class MetaService {
  metaAttr: Array<string> = ["charset", "http-equiv", "id", "itemprop",
    "name", "description", "property", "scheme", "url"];
  constructor(private title: Title,
    private meta: Meta,
    private share: ProjdataService,
    @Inject(DOCUMENT) private dom,
    @Inject(DOCUMENT) private doc:Document
  ) { }

  async updateMeta(route: string) {
  
    if (Object.prototype.hasOwnProperty.call(META_INFO, route)) {
      const { title, data } = META_INFO[route];
      await this.removeExistingMeta(this.share.getData("prevMetaInfo"));
      this.updateTitle(title);
      this.updateDescription(data);
    }
    this.addCanonicalURL(route);
  }

  async updateMetaWithApi(res: any, route: string) {
    if (res && route && res[route]) {
      const { title, data } = res[route];
      await this.removeExistingMeta(this.share.getData("prevMetaInfo"));
      this.updateTitle(title);
      this.updateDescription(data);
    }
    this.addCanonicalURL(route);
  }

  updateTitle(title: string) {
    if (title) {
      this.title.setTitle(title);
    }
  }

  updateDescription_new(desc: string, title: string) {
    this.title.setTitle(title);
    this.meta.updateTag({ name: 'description', content: desc })
   }


  removeExistingMeta(data: Array<string>) {
    if (data) {
      data.forEach((attr) => {
        // document.querySelector(`meta[${attr}]`).remove()
        this.meta.removeTag(attr);
      });
    }
  }

  

  async updateDescription(data: Array<any>) {
    let history: string[] = [];
    if (data && data.length > 0) {
      await data.forEach(async (object: any) => {
        if (Object.keys(object).length > 0) {
          this.meta.updateTag(object)
          await Object.keys(object).map(async (key) => {
            if (this.metaAttr.includes(key))
              await history.push(`${key}='${object[key]}'`);
          }).filter((e) => e);
          this.share.setData('prevMetaInfo', history);
        }
      });
    }
  }

//   addCanonicalURL(newCanonicalUrl: string) {
//     let link: HTMLLinkElement  = this.doc.querySelector('link[rel="canonical"]');
//     let canonicalURl = `https://amerkilaspices.com${newCanonicalUrl}`;
//     link.setAttribute('href', canonicalURl);
//  }

addCanonicalURL(url:string){
  const head = this.dom.getElementsByTagName('head')[0];
  var element: HTMLLinkElement= this.dom.querySelector(`link[rel='canonical']`) || null
  if (element==null) {
    this.createLinkForCanonicalURL();
  }
  element.setAttribute('rel','canonical')
  let canonicalURl = `https://amerkilaspices.com${url}`;
  element.setAttribute('href',canonicalURl)
}


 createLinkForCanonicalURL() {
  let link: HTMLLinkElement = this.doc.createElement('link');
  link.setAttribute('rel', 'canonical');
  this.doc.head.appendChild(link);
  link.setAttribute('href', this.doc.URL);
}




}
